// Subscription periodicity values as exposed by the backend (`product_version.periodicity`).
// Centralized here so the literals 30 / 365 stop floating around the codebase.

export const SUBSCRIPTION_PERIODICITIES = {
	MONTHLY: 30,
	YEARLY: 365,
} as const;

export type SubscriptionPeriodicity =
	(typeof SUBSCRIPTION_PERIODICITIES)[keyof typeof SUBSCRIPTION_PERIODICITIES];

export const isYearlyPeriodicity = (
	periodicity: number | undefined | null,
): boolean => periodicity === SUBSCRIPTION_PERIODICITIES.YEARLY;

export const isMonthlyPeriodicity = (
	periodicity: number | undefined | null,
): boolean => periodicity === SUBSCRIPTION_PERIODICITIES.MONTHLY;
